import { Navigate, Outlet } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { GoalsRootPageDocument } from 'generated/resources/graphql'

import NotFound from 'modules/core/components/NotFound'
import SectionContainer from 'modules/core/components/SectionContainer'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/goals/lib/CollectionsBootstrap'

const Container = () => {
  const { navigation } = useNavigation()
  const { company } = useCurrentSession()
  const { data, loading } = useQuery(GoalsRootPageDocument, {
    variables: { companyId: company.id },
  })

  const goalsFeatureEnabled = data?.companies.featureAvailabilitiesConnection.nodes[0]?.available

  if (loading) {
    return (
      <Box width="full" alignItems="center" height="full" justifyContent="center">
        <Spinner />
      </Box>
    )
  }

  if (!goalsFeatureEnabled && data?.apiCore._policies.accessGoalsConfigCreate.can) {
    return <Navigate to={navigation.appStore.fullPath()} />
  }

  if (!goalsFeatureEnabled) return <NotFound />

  return <Outlet />
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <SectionContainer>
        <Container />
      </SectionContainer>
    </CollectionsBootstrap>
  )
}

export default RootPage
